export default {
	TRANSCRIPT: 1,
	QUESTION: 2,
}
